import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ComponentBase } from '../../core/_infrastructure/classes/componentBase';
import { AuthService } from '../../core/_infrastructure/classes/services/auth.service';
import { InformesService } from './informes.service';
import { Tc } from '../../core/_infrastructure/types/common';
import { NotificationService } from '../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../core/_infrastructure/classes/handlers/exceptionManager';
import { HttpParams } from '@angular/common/http';
import { EnumIdsTcInformesEstadisticos, EnumIdsTcInformesGenerales, EnumIdsTwTcTipoInforme } from './informes.types';

@Component({
    selector: 'app-informes-list',
    templateUrl: './informes-list.component.html',
    styleUrls: ['./informes-list.component.scss'],
})
export class InformesListComponent extends ComponentBase implements OnInit {
    listInformesGenerales: Tc[];
    listInformesEstadisticos: Tc[];

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private informesService: InformesService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.GetInformesGenerales();
        this.GetInformesEstadisticos();

        this.form = this.fb.group({
            IdInformeGeneral: null,
            IdInformeEstadistico: null,
        });
    }

    private GetInformesGenerales(): void {
        let params = new HttpParams();
        params = params.append('idTipoInforme', EnumIdsTwTcTipoInforme.ID_GENERAL);

        this.informesService.getAllTiposInforme(params).subscribe(res => {
            this.listInformesGenerales = res;
        });
    }

    private GetInformesEstadisticos(): void {
        let params = new HttpParams();
        params = params.append('idTipoInforme', EnumIdsTwTcTipoInforme.ID_ESTADISTICO);

        this.informesService.getAllTiposInforme(params).subscribe(res => {
            this.listInformesEstadisticos = res;
        });
    }

    onSelectTipoInformeGeneral() {
        const idInforme = this.getSelectedTipoInforme('IdInformeGeneral');

        switch (idInforme.Id) {
            case EnumIdsTcInformesGenerales.INFORME_TASAS:
                this.router.navigate(['/global/informes/informetasas']);
                break;
            case EnumIdsTcInformesGenerales.INFORME_TASAS_EXPORTACION:
                this.router.navigate(['/global/informes/informetasasexportacion']);
                break;

            default:
                return;
        }
    }

    onSelectTipoInformeEstadistico() {
        const idInforme = this.getSelectedTipoInforme('IdInformeEstadistico');

        switch (idInforme.Id) {
            case EnumIdsTcInformesEstadisticos.INFORME_IMPORTACIONES:
                this.router.navigate(['/global/informes/informeimportaciones']);
                break;

            case EnumIdsTcInformesEstadisticos.INFORME_EXPORTACIONES:
                this.router.navigate(['/global/informes/informeexportaciones']);
                break;

            case EnumIdsTcInformesEstadisticos.INFORME_INSPECCIONES:
                this.router.navigate(['/global/informes/informeinspecciones']);
                break;
            case EnumIdsTcInformesEstadisticos.INFORME_INSPECCIONES_EXPORTACION:
                this.router.navigate(['/global/informes/informeinspeccionesexportacion']);
                break;

            default:
                return;
        }
    }

    getSelectedTipoInforme(idTipo: string): any {
        this.removeValidators(idTipo);
        this.addValidator(idTipo, Validators.required);

        if (this.isFieldInvalidNoSubmit(idTipo, 'required')) {
            return;
        }

        this.removeValidators(idTipo);

        return this.form.controls[idTipo].value;
    }
}
